var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtotal-row"},[_c('added-to-cart',{attrs:{"prebuild-price":_vm.getPrebuildPrice,"prebuild-cover-image":_vm.getPrebuildCoverImage,"prebuild-name":_vm.getPrebuildName}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }